import './seatplan-group-directive-controller';
import template from './seatplan-group-directive.tpl.html';

/**
 * @ngdoc directive
 * @name festzelt-os.seatplans.directive:seatplan-group
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="festzelt-os.seatplans">
 <file name="index.html">
 <seatplan-group></seatplan-group>
 </file>
 </example>
 *
 */
angular
    .module('festzelt-os.seatplans')
    .component('seatplanGroup', {
        restrict: 'EA',
        templateUrl: template,
        replace: false,
        controllerAs: 'vm',
        controller: 'SeatplanGroupCtrl',
        bindings: {
            groupId: '@',
            clickable: '@',
            bookings: '@',
            onClick: '&',
            onDblClick: '&',
            onSelectionChange: '&',
            onFullSelectionUpdate: '&',
            onUnSelectable: '&',
            bookingInformation: '=',
            blockedElements: '=',
            resetSelected: '=',
            currentSelected: '<',
            hideLegend: '<',
            blockMultipleSelectionOfOneElement: '<'
        }
    });



// WEBPACK FOOTER //
// ./src/app/pages/seatplans/directives/seatplan-group-directive.js